// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'alexa';

export const Component = () => (
  <path
    fill='currentColor'
    d='M9 0C4.032 0 0 4.032 0 9c0 4.536 3.384 8.352 7.776 8.928v-1.8c0-.504-.288-.936-.792-1.152a6.32 6.32 0 0 1-4.248-6.12c.072-3.456 2.88-6.192 6.336-6.12 3.456 0 6.192 2.808 6.192 6.264v.936c-.792 5.04-7.344 7.92-7.416 7.92.36.072.792.072 1.224.072C13.968 18 18 13.968 18 9s-4.032-9-9-9z'
  />
);

export const viewBox = '0 0 18 18';
